import { useEffect, useState } from 'react';
import http from '../components/http/http';

export function useUserFirstLetter() {
  const [firstLetter, setFirstLetter] = useState<string | undefined>(undefined);

  useEffect(() => {
    http.get('/api/users/auth/me').then((user) => {
      if (user && user.email) {
        setFirstLetter(user.email[0].toUpperCase());
      }
    });
  }, []);

  return firstLetter;
} 